module.exports = __webpack_public_path__ + "assets/6db17555f3501cba8e2c5f5b3c47d421.jpg";